import PrototypesListScreen from './PrototypesListScreen';

export default (props: any) => (
  <PrototypesListScreen {...props} showRecommendations={true} />
);
